(function () {
  var SLIDER_GAP_PX = 20;

  function initCollectionTabs(root) {
    if (root.dataset.collectionTabsInitialized === 'true') return;
    root.dataset.collectionTabsInitialized = 'true';

    var tabButtons = root.querySelectorAll('[data-collection-tab]');
    var panels = root.querySelectorAll('[data-collection-tab-panel]');
    if (!tabButtons.length || !panels.length) return;

    var prevBtn = root.querySelector('[data-collection-tabs-arrow="prev"]');
    var nextBtn = root.querySelector('[data-collection-tabs-arrow="next"]');

    var scrollCleanup = null;
    var resizeObserver = null;

    function getActiveSlider() {
      var panel = root.querySelector('[data-collection-tab-panel].is-active');
      return panel ? panel.querySelector('.custom-tab-slider') : null;
    }

    function maxScrollLeft(slider) {
      return Math.max(0, slider.scrollWidth - slider.clientWidth);
    }

    function updateTopArrows() {
      if (!prevBtn || !nextBtn) return;
      var slider = getActiveSlider();
      if (!slider) {
        prevBtn.classList.add('is-disabled');
        nextBtn.classList.add('is-disabled');
        prevBtn.setAttribute('aria-disabled', 'true');
        nextBtn.setAttribute('aria-disabled', 'true');
        return;
      }

      var max = maxScrollLeft(slider);
      var left = slider.scrollLeft;
      var atStart = left <= 2;
      var atEnd = max <= 2 || left >= max - 2;

      prevBtn.classList.toggle('is-disabled', atStart);
      nextBtn.classList.toggle('is-disabled', atEnd);
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    function rebindActiveSliderScroll() {
      if (scrollCleanup) {
        scrollCleanup();
        scrollCleanup = null;
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }

      var slider = getActiveSlider();
      if (!slider) return;

      var onScroll = function () {
        updateTopArrows();
      };
      slider.addEventListener('scroll', onScroll, { passive: true });
      scrollCleanup = function () {
        slider.removeEventListener('scroll', onScroll);
      };

      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(function () {
          updateTopArrows();
        });
        resizeObserver.observe(slider);
      }
    }

    function refreshTopChrome() {
      rebindActiveSliderScroll();
      updateTopArrows();
    }

    function activateTab(targetId) {
      tabButtons.forEach(function (btn) {
        var isMatch = btn.getAttribute('data-target') === targetId;
        btn.classList.toggle('is-active', isMatch);
        btn.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isMatch = panel.id === targetId;
        panel.classList.toggle('is-active', isMatch);
        panel.toggleAttribute('hidden', !isMatch);
        panel.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
        if (isMatch) {
          var slider = panel.querySelector('.custom-tab-slider');
          if (slider) {
            slider.scrollLeft = 0;
          }
        }
      });

      refreshTopChrome();
      window.requestAnimationFrame(function () {
        updateTopArrows();
        window.setTimeout(updateTopArrows, 150);
        window.setTimeout(updateTopArrows, 500);
      });
    }

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('data-target');
        if (!targetId) return;
        activateTab(targetId);
      });
    });

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function () {
        var slider = getActiveSlider();
        if (!slider) return;
        var max = maxScrollLeft(slider);
        if (max <= 0) return;
        var item = slider.querySelector('.custom-tab-item');
        if (!item) return;
        var amount = (item.offsetWidth + SLIDER_GAP_PX) * 2;
        var delta = Math.min(amount, slider.scrollLeft);
        if (delta < 1) return;
        slider.scrollBy({ left: -delta, behavior: 'smooth' });
        window.setTimeout(updateTopArrows, 400);
      });

      nextBtn.addEventListener('click', function () {
        var slider = getActiveSlider();
        if (!slider) return;
        var max = maxScrollLeft(slider);
        if (max <= 0) return;
        var item = slider.querySelector('.custom-tab-item');
        if (!item) return;
        var amount = (item.offsetWidth + SLIDER_GAP_PX) * 2;
        var room = max - slider.scrollLeft;
        var delta = Math.min(amount, room);
        if (delta < 1) return;
        slider.scrollBy({ left: delta, behavior: 'smooth' });
        window.setTimeout(updateTopArrows, 400);
      });
    }

    function onResize() {
      updateTopArrows();
    }
    window.addEventListener('resize', onResize);
    window.addEventListener('load', updateTopArrows);

    refreshTopChrome();
    window.requestAnimationFrame(function () {
      updateTopArrows();
      window.setTimeout(updateTopArrows, 200);
    });
  }

  document.querySelectorAll('[data-collection-tabs]').forEach(initCollectionTabs);

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('[data-collection-tabs]');
    if (container) initCollectionTabs(container);
  });
})();
